export enum ShopFilterStates {
    all,
    oneShop
}
